<template>
  <div :class="cssClass.parent" @click="click">
    <Icon2 v-if="icon[variant]" :variant="icon[variant]" :size="16" />
    <div :class="cssClass.content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';

export default {
  props: {
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false,
      default: 'question'
    },
    position: {
      type: String,
      required: false
    }
  },
  components: {
    Icon2
  },
  data() {
    return {
      icon: {
        attention: 'attention',
        question: 'question-square'
      }
    };
  },
  computed: {
    cssClass() {
      return {
        parent: {
          'c-tooltip': true,
          ['c-tooltip--' + this.size]: this.size,
          ['c-tooltip--' + this.variant]: this.variant
        },
        content: {
          'c-tooltip__content': true,
          ['c-tooltip--' + this.variant + '__content']: this.variant,
          ['c-tooltip__content__' + this.position]: this.position
        }
      };
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
